import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import PaymentCG from '../../../Components/Block/SaleBlock/PaymentCG/PaymentCG';
import { cgTypeEnum } from '../../../utilities/enums/cgTypeEnum';
import images from './images/images.js';
import { updatePaymentMethod } from '../../Block/UpdatePaymentMethodBlock/updatePaymentMethodSlice';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import Config from 'app/Config';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import ProviderManager from '../../../provider/providerManager';
import LocalLoader from '../../Shared/LocalLoader/LocalLoader';
import './EntityPaymentPage.scss';


const EntityPaymentPage = (props) => {
  const [paymentValid, setPaymentValid] = useState(false);
  const [entityDetails, setEntityDetails] = useState(null);
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [paymentError, setPaymentError] = useState(null);
  const [processError, setProcessError] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [paymentCGLoaded, setPaymentCGLoaded] = useState(false);
  const [hasDebt, setHasDebt] = useState(false);
  const [tvUpdated, setTvUpdated] = useState(false);
  const magicLinkParameters = props.magicLinkParameters;

  useEffect(() => {
    if (magicLinkParameters) {
      if (magicLinkParameters.entityDetails) {
        try {
          const parsedEntityDetails = JSON.parse(magicLinkParameters.entityDetails);
          setEntityDetails(parsedEntityDetails);
        } catch (error) {
          console.error('Error parsing entity details:', error);
        }
      }
    }
  }, [magicLinkParameters]);

  useEffect(() => {
    if (props.paymentConfirmationNumber && props.creditCardToken) {
      setPaymentValid(true);
    }
  }, [props.paymentConfirmationNumber, props.creditCardToken]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPaymentCGLoaded(true);
    }, 7000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    if (props.data?.isLoading && !props.loader?.isLoading) {
      props.showAppLoader();
    } else {
      if (props.loader?.isLoading) {
        setTimeout(() => {
          props.hideAppLoader();
        }, 300);
      }
    }
  }, [props.data?.isLoading]);

  const handlePaymentValidation = (isValid) => {
    console.log('Payment validation result:', isValid);
  };

  const handlePaymentError = (errorId) => {
    console.error('Payment error:', errorId);
    setPaymentError(errorId);

    setProcessError(errorMessages[errorId] || 'שגיאה בעדכון פרטי התשלום');
    setShowResult(true);
  };

  const handleSubmitClick = () => {
    setProcessError(null);
    setShowResult(false);
    handlePaymentCompletion();
  };

  const handleRetry = () => {
    setProcessError(null);
    setPaymentCompleted(false);
    setShowResult(false);
    setPaymentValid(false);
    setPaymentError(null);
    setHasDebt(false);
    setTvUpdated(false);
  };

  const handlePaymentCompletion = async () => {
    try {
      if (!entityDetails) {
        throw new Error('No entity details found');
      }

      const allAccounts = [];
      let firstConsumerId = null;

      for (const [consumerId, accounts] of Object.entries(entityDetails)) {
        if (!firstConsumerId) {
          firstConsumerId = consumerId;
        }
        const banNumbers = accounts.map(account => account.number);
        allAccounts.push(...banNumbers);
      }

      const updateData = {
        AccountList: allAccounts,
        CCToken: props.creditCardToken,
        CardYear: props.cardYear,
        CardMonth: props.cardMonth,
        CardCvv: props.cardCvv,
        CreditCardType: props.cardType || '',
        CCFourLastNumbers: props.last4Digits || '',
        PaymentOwnerFirstName: props.formData?.firstName,
        PaymentOwnerLastName: props.formData?.lastName,
        ConsumerId: firstConsumerId,
        IdNumber: magicLinkParameters?.idNumber,
        PrivateUserIdNumber: magicLinkParameters?.idNumber,
        PhoneNumber: magicLinkParameters?.phoneNumber,
        IsBusiness: false,
        EMail: magicLinkParameters?.email,
        PaymentMethodType: 'CC',
        PaymentType: 'UpdatePaymentMethod',
        AuthNo: props.paymentConfirmationNumber,
        PaymentEntityId: props.formData?.id,
        PaymentEntityFirstName: props.formData?.firstName,
        PaymentEntityLastName: props.formData?.lastName,
        PaymentEntityCity: props.formData?.addressData.city,
        PaymentEntityStreet: props.formData?.addressData.street,
        PaymentEntityZip: props.formData?.addressData.zip
      };

      const result = await props.updatePaymentMethod(updateData);
      const allBansUpdated = result.payload.Body?.banList?.every(ban => ban.updated === true) ?? false;
      const allResultsSuccessful = result.payload.Body?.resultList?.every(resultItem => resultItem.statusCode === "00") ?? false;

      const isSuccess = result.payload.Header?.ReturnCode === 0 &&
                        result.payload.Body?.statusCode === "00" &&
                        result.payload.Body?.validCC === true &&
                        allBansUpdated &&
                        allResultsSuccessful
      if (isSuccess) {
        const responseHasDebt = result.payload.Body?.banList?.some(ban => ban.hasDebt === true) ?? false;
        const responseTvUpdated = result.payload.Body?.tvUpdated === true;

        setHasDebt(responseHasDebt);
        setTvUpdated(responseTvUpdated);
        setPaymentCompleted(true);
        setShowResult(true);

        if (props.onPaymentSuccess) {
          props.onPaymentSuccess({
            accountList: allAccounts,
            newCreditCardLast4: props.last4Digits || ''
          });
        }

        await handleUploadFileToJet();

      } else {
        let errorMessage = 'שגיאה בעדכון פרטי התשלום';

        if (result.payload?.StatusDescription) {
          errorMessage += `: ${result.payload.StatusDescription}`;
        } else if (result.payload?.FailedUpdateReason) {
          const reasons = {
            'BanUnrelatedToCustomer': 'החשבונות אינם קשורים ללקוח',
            'BanDontMatchId': 'מספר הזהות אינו תואם לחשבונות - נדרש מספר הזהות של בעל החשבונות',
          };
          errorMessage += `: ${reasons[result.payload.FailedUpdateReason] || result.payload.FailedUpdateReason}`;
        }

        setProcessError(errorMessage);
        setShowResult(true);

        if (props.onPaymentFailure) {
          props.onPaymentFailure({});
        }

        throw new Error('Failed to update payment method');
      }

    } catch (error) {
      if (!paymentCompleted && !processError) {
        setProcessError('שגיאה בעדכון פרטי התשלום. אנא נסה שוב.');
        setShowResult(true);

        if (props.onPaymentFailure) {
          props.onPaymentFailure({});
        }
      }
      setPaymentCompleted(false);
      setPaymentValid(false);
    }
  };

  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const handleUploadFileToJet = async () => {
    try {
      if (!entityDetails || !magicLinkParameters || !props.formData) {
        console.error('Missing required data for UploadFileToJet');
        return;
      }

      const firstConsumerId = Object.keys(entityDetails)[0];
      const firstAccount = entityDetails[firstConsumerId][0];

      const fileBase64 = await convertFileToBase64(props.formData.selectedFile);

      const uploadParams = {
        phoneNumber: magicLinkParameters.phoneNumber,
        ban: firstAccount.number,
        fileStream: fileBase64,
        fileName: props.formData.selectedFile.name,
        consumerId: firstConsumerId,
        accountId: magicLinkParameters?.idNumber
      };

      const result = await ProviderManager.getProviderData('UploadFileToJet', uploadParams);

      if (result.Header?.ReturnCode === 0 && result.Body?.isSuccess) {
      } else {
        console.error('UploadFileToJet failed:', {
          headerReturnCode: result.Header?.ReturnCode,
          bodyIsSuccess: result.Body?.isSuccess,
          bodyCodeError: result.Body?.codeError,
          bodyReturnCodeMessage: result.Body?.returnCodeMessage,
          fullBody: result.Body
        });
      }

    } catch (error) {
      console.error('Error in UploadFileToJet:', error);
    }
  };

  if (showResult) {
    return (
      <div className={`content-entity-payment ${isMobile ? 'isMobile' : ''}`}>
        {paymentCompleted ? (
          <div className="result-screen success">
            <Image src={images.success} className="iconheadline" />
            <span className="result-title">העדכון בוצע בהצלחה!</span>
            <div className="result-details">
              {/* Common subtitle for all success scenarios */}
              <div className="success-subtitle">
                בעוד מספר דקות נשלח אליך מייל וסמס<br/>
                עם פרטי העדכון
              </div>

              <div className="detail-item">
                {hasDebt ? (
                  // Message for hasDebt: true - debt scenario
                  <div className="info-message-container">
                    <div className="message-content">
                      <span className='info-message-text'>
                        לפי רישומינו, קיים חוב בחשבונך<br/>
                        <a
                          href="#"
                          className="debt-payment-link"
                          onClick={(e) => {
                            e.preventDefault();
                            // TODO: Navigate to payment page or open payment flow
                            console.log('Navigate to debt payment');
                          }}
                        >
                          <Image src={images.arrowLeft} className="debt-arrow-icon" alt="arrow" />
                          לתשלום החוב
                        </a>
                      </span>
                    </div>
                    <div className="info-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M11.6246 1C15.4449 1 18.6131 4.25262 18.6364 8.24609C18.6362 10.6609 17.4717 12.7648 15.8414 13.9844V15.7783C15.8414 16.2805 15.4214 16.6866 14.9323 16.7344L8.52698 17.2607H8.43323C8.20032 17.2607 7.94392 17.1654 7.78088 16.998C7.59461 16.8307 7.43141 16.5676 7.43127 16.3047V13.9609C5.56799 12.6458 4.63646 10.6849 4.63635 8.24609C4.63635 4.25264 7.80437 1.00004 11.6246 1ZM11.6246 2.91309C8.806 2.91309 6.49978 5.30479 6.52307 8.24609C6.52319 10.2066 7.26854 11.6412 8.87561 12.5977C9.1551 12.7889 9.29548 13.0999 9.29553 13.4346V15.2764L13.9537 14.8936V13.4346C13.9538 13.0999 14.1169 12.765 14.4196 12.5977C15.887 11.7847 16.7262 10.1589 16.7496 8.24609C16.7496 5.30483 14.4432 2.91316 11.6246 2.91309Z" fill="black"/>
                        <path d="M14.8626 19.7955L8.50319 20.2738H8.43331C7.94413 20.2738 7.54812 19.8912 7.50153 19.389C7.45494 18.8629 7.85095 18.4086 8.36343 18.3607L14.7228 17.8825C15.2586 17.8347 15.7012 18.2412 15.7245 18.7673C15.7711 19.2934 15.3751 19.7477 14.8626 19.7955Z" fill="black"/>
                        <path d="M12.836 22.8086L10.5531 22.9999H10.4832C9.99405 22.9999 9.59805 22.6173 9.55146 22.1152C9.50487 21.5891 9.90087 21.1347 10.4134 21.0869L12.7195 20.8956C13.232 20.8717 13.6746 21.2543 13.6979 21.7804C13.7445 22.3065 13.3485 22.7608 12.836 22.8086Z" fill="black"/>
                        <path d="M15.3286 8.22173C15.2821 8.65217 14.9326 8.98695 14.5133 8.98695H14.4435C14.0009 8.93912 13.6747 8.5326 13.7213 8.07825C13.8611 6.71521 12.6964 6.21304 12.5566 6.16521C12.1373 5.99782 11.9276 5.51956 12.0674 5.08912C12.2072 4.65869 12.6731 4.41956 13.0924 4.58695C13.9543 4.89782 15.5383 6.06956 15.3286 8.22173Z" fill="black"/>
                      </svg>
                    </div>
                  </div>
                ) : tvUpdated ? (
                  // Message for TvUpdated: true AND hasDebt: false - TV scenario
                  <div className="info-message-container">
                    <div className="message-content">
                      <span className='info-message-text'>
                        <span className="tv-attention-text">לתשומת ליבך</span><br/>
                        כדי לחדש את הצפייה ב{window.Config.brand_Name_HE} TV יש לכבות<br/>
                        ולהדליק את הממיר
                      </span>
                    </div>
                    <div className="info-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M11.6246 1C15.4449 1 18.6131 4.25262 18.6364 8.24609C18.6362 10.6609 17.4717 12.7648 15.8414 13.9844V15.7783C15.8414 16.2805 15.4214 16.6866 14.9323 16.7344L8.52698 17.2607H8.43323C8.20032 17.2607 7.94392 17.1654 7.78088 16.998C7.59461 16.8307 7.43141 16.5676 7.43127 16.3047V13.9609C5.56799 12.6458 4.63646 10.6849 4.63635 8.24609C4.63635 4.25264 7.80437 1.00004 11.6246 1ZM11.6246 2.91309C8.806 2.91309 6.49978 5.30479 6.52307 8.24609C6.52319 10.2066 7.26854 11.6412 8.87561 12.5977C9.1551 12.7889 9.29548 13.0999 9.29553 13.4346V15.2764L13.9537 14.8936V13.4346C13.9538 13.0999 14.1169 12.765 14.4196 12.5977C15.887 11.7847 16.7262 10.1589 16.7496 8.24609C16.7496 5.30483 14.4432 2.91316 11.6246 2.91309Z" fill="black"/>
                        <path d="M14.8626 19.7955L8.50319 20.2738H8.43331C7.94413 20.2738 7.54812 19.8912 7.50153 19.389C7.45494 18.8629 7.85095 18.4086 8.36343 18.3607L14.7228 17.8825C15.2586 17.8347 15.7012 18.2412 15.7245 18.7673C15.7711 19.2934 15.3751 19.7477 14.8626 19.7955Z" fill="black"/>
                        <path d="M12.836 22.8086L10.5531 22.9999H10.4832C9.99405 22.9999 9.59805 22.6173 9.55146 22.1152C9.50487 21.5891 9.90087 21.1347 10.4134 21.0869L12.7195 20.8956C13.232 20.8717 13.6746 21.2543 13.6979 21.7804C13.7445 22.3065 13.3485 22.7608 12.836 22.8086Z" fill="black"/>
                        <path d="M15.3286 8.22173C15.2821 8.65217 14.9326 8.98695 14.5133 8.98695H14.4435C14.0009 8.93912 13.6747 8.5326 13.7213 8.07825C13.8611 6.71521 12.6964 6.21304 12.5566 6.16521C12.1373 5.99782 11.9276 5.51956 12.0674 5.08912C12.2072 4.65869 12.6731 4.41956 13.0924 4.58695C13.9543 4.89782 15.5383 6.06956 15.3286 8.22173Z" fill="black"/>
                      </svg>
                    </div>
                  </div>
                ) : (
                  // Default message - no additional message needed since subtitle covers it
                  <div style={{minHeight: '20px'}}></div>
                )}
              </div>
              <div className='button-wrapper'>
                    <BtnSubmit
                        isBusiness={false}
                        text='לאיזור האישי'
                        onclick={() => {
                          window.location.href = Config.lobbyUrl;
                        }}
                        formid='esim-block'
                        isDisplayArrows={false}
                        isDisplayWhatsAppIcon={false}
                    />
                </div>
            </div>
          </div>
        ) : (
          <div className="result-screen error">
              <Image src={images.error} className="iconheadline" />
              <span className="result-title">משהו השתבש ולא הצלחנו לעדכן את הכרטיס את אמצעי התשלום</span>
            <div className="result-details">
              <button
                className='contact-button-styled'
                onClick={() => {
                  if (isMobile) {
                    window.location.href = `tel:${window.Config.financeCallNumber1}`;
                  }
                }}
              >
                <span className="contact-button-text">חייגו {window.Config.financeCallNumber1} לנציג שירות</span>
              </button>
            </div>
            <div className="result-actions">
            <div className='button-wrapper'>
                    <BtnSubmit
                        isBusiness={false}
                        text='לאזור האישי'
                        onclick={() => {
                          window.location.href = Config.lobbyUrl;
                        }}
                        isDisplayArrows={false}
                        isDisplayWhatsAppIcon={false}
                    />
                </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`content-entity-payment ${isMobile ? 'isMobile' : ''}`}>
      <span className="page-title">פרטי כרטיס האשראי החדש</span>

      <div className="selection-btn">
        <div className="payment-card">
          <div className="card-header">
            <Image src={images.creditCard} className='credit-card-logo' />
            <span className="card-title">אמצעי לעדכון</span>
          </div>
          <div className="card-divider"></div>
          <div className="accounts-frame payment-page">
            {entityDetails ? (
              <div className="entity-details">
                {Object.entries(entityDetails).map(([consumerId, accounts]) => (
                  <div key={consumerId} className="entity-group">
                    <span className="payment-accounts-numbers">חשבונות שיעודכנו:</span>
                    <div className="payment-accounts-numbers">
                      {accounts.map((account, index) => account.number).join(' | ')}
                    </div>
                  </div>
                ))}
              </div>
            ) : magicLinkParameters ? (
              <div>
                <span className="accounts-info">
                </span>
                {magicLinkParameters.phoneNumber && (
                  <div className="phone-info">
                    מספר טלפון: {magicLinkParameters.phoneNumber}
                  </div>
                )}
              </div>
            ) : (
              <div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="payment-cg-container">
        {!paymentCGLoaded && (
          <div className="payment-loading-wrapper">
            <LocalLoader />
            <p className="loading-text">
              טוען את טופס התשלום...
            </p>
          </div>
        )}
        <div className={`payment-cg-wrapper ${!paymentCGLoaded ? 'hidden' : ''}`}>
          <PaymentCG
            type={cgTypeEnum.CHECKCARD}
            customerId={props.formData?.id}
            idNumber={props.formData?.id}
            totalPrice={0}
            isUpdatePayment={true}
            onValid={handlePaymentValidation}
            onError={handlePaymentError}
            onSubmit={false}
            isShowTerms={false}
            isShowIdNumber={true}
            edit={paymentError !== null}
            isPaymentErr={paymentError !== null}
            source="EntityPaymentBlock"
          />
        </div>
      </div>

      <div className="payment-submit-container">
        <button
          className="payment-submit-button"
          onClick={handleSubmitClick}
          disabled={!paymentValid || !paymentCGLoaded || props.data?.isLoading}
        >
        עדכון וסיום
        </button>
        {(!paymentValid || !paymentCGLoaded) && (
          <p style={{ color: '#666', marginTop: '10px', fontSize: '14px' }}>
          </p>
        )}
      </div>


    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    totalPrice: state.payment?.totalPrice,
    customerId: state.user?.customerId,
    magicLinkParameters: state.authentication?.loginData?.magicLinkParameters,

    paymentConfirmationNumber: state.PaymentCG?.form?.confirmationNumber,
    creditCardToken: state.PaymentCG?.CCToken,
    last4Digits: state.PaymentCG?.Credit4Digits,
    cardType: state.PaymentCG?.CCType,
    cardYear: state.PaymentCG?.form?.CardDueYear,
    cardMonth: state.PaymentCG?.form?.CardDueMonth,
    cardCvv: state.PaymentCG?.CCvv,
    idNumber: state.PaymentCG?.form?.id,
    paymentCompleted: state.PaymentCG?.emvStep2CompletedSuccessfully,

    userFirstName: state.user?.firstName,
    userLastName: state.user?.lastName,
    userEmail: state.user?.email,
    userPhone: state.user?.phoneNumber,

    data: state.updatePayment,
    loader: state.loader,
  };
};

const mapDispatchToProps = {
  updatePaymentMethod,
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(EntityPaymentPage);
